import mock from 'api/mockFastApi';

mock.onPost('/services/esign/withdraw/retirement').reply(() => [200, "/epargne"]);
